import React, { useEffect } from "react";

import Main from '../components/AboutUs/Main'
import OurAmazing from "../components/AboutUs/OurAmazing";
import OurClients from "../components/AboutUs/OurClients";
import GlobalAwards from "../components/AboutUs/GlobalAwards";
import YourTradingJourney from "../components/Home/YourTradingJourney";

function AboutUs () {
 
    useEffect(() => {
        window.scrollTo(0, 0);
      }, []);
      
    return(
        <div className="bg-[#F8F8F8]">
            <Main/>
            <OurAmazing/>
            <OurClients/>
            <GlobalAwards/>
            <YourTradingJourney/>
        </div>
    );
}

export default AboutUs;